/**
 * Tenant Variables — Dynamic variable registry per tenant.
 *
 * Define {{var.promo_link}} once, use in all templates/sequences.
 * Resolved at SEND TIME, not template save time.
 * Change value once → all future sends use new value.
 *
 * Schema from: docs/masterplan/09-council-database-schema.md (line 355)
 */

import { pgTable, uuid, varchar, jsonb, timestamp, uniqueIndex } from "drizzle-orm/pg-core";

export const tenantVariables = pgTable("tenant_variables", {
  id: uuid("id").primaryKey().defaultRandom(),
  tenantId: uuid("tenant_id").notNull(),
  key: varchar("key", { length: 200 }).notNull(),
  value: jsonb("value").notNull(),
  description: varchar("description", { length: 500 }),
  updatedBy: uuid("updated_by").notNull(),
  updatedAt: timestamp("updated_at", { withTimezone: true }).notNull().defaultNow(),
  createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
}, (table) => [
  uniqueIndex("uq_tenant_variable").on(table.tenantId, table.key),
]);
